import React, {useMemo} from 'react';
import {Route} from 'react-router-dom';
import loadable from '@loadable/component';
import {EzAppLayout} from '@ezcater/recipe';
import {createFeatureFlagsClient} from '@ezcater/feature-flags-js';
import {FeatureFlagsProvider} from '@ezcater/feature-flags-react';
import {EzManageNavRoute, EzManageNavSwitch} from './EzManageNav';
import {
  DELIVERY_MANAGEMENT_DELIVERIES_PATH,
  DELIVERY_MANAGEMENT_DRIVERS_PATH,
  DELIVERY_MANAGEMENT_EDIT_DRIVER_PATH,
  DELIVERY_MANAGEMENT_NEW_DRIVER_PATH,
  DELIVERY_MANAGEMENT_REPORTING_PATH,
} from '../paths';
import {CurrentAccountStoresProvider} from './DeliveryManagement';
import {useEnvironment} from './Environment';

const Deliveries = loadable(() => import('../pages/DeliveryManagement/Deliveries'));
const DriverEdit = loadable(() => import('../pages/DeliveryManagement/DriverEdit'));
const Drivers = loadable(() => import('../pages/DeliveryManagement/Drivers'));
const Reporting = loadable(() => import('../pages/DeliveryManagement/Reporting'));

const RoutesContainer = () => {
  return (
    <CurrentAccountStoresProvider>
      <Route exact path={[DELIVERY_MANAGEMENT_DELIVERIES_PATH, '/']} component={Deliveries} />
      <Route exact path={DELIVERY_MANAGEMENT_DRIVERS_PATH} component={Drivers} />
      <Route exact path={DELIVERY_MANAGEMENT_REPORTING_PATH} component={Reporting} />
      <Route
        exact
        path={[DELIVERY_MANAGEMENT_EDIT_DRIVER_PATH, DELIVERY_MANAGEMENT_NEW_DRIVER_PATH]}
        component={DriverEdit}
      />
    </CurrentAccountStoresProvider>
  );
};

const DeliveryManagementRoutes = () => {
  const {featureFlagHost} = useEnvironment();
  const featureFlagsClient = useMemo(
    () =>
      createFeatureFlagsClient({
        host: featureFlagHost,
      }),
    [featureFlagHost]
  );

  return (
    <EzAppLayout>
      <EzManageNavSwitch appName="DELIVERY">
        <FeatureFlagsProvider client={featureFlagsClient}>
          <EzManageNavRoute path="/" component={RoutesContainer} />
        </FeatureFlagsProvider>
      </EzManageNavSwitch>
    </EzAppLayout>
  );
};

export default DeliveryManagementRoutes;
